module.exports = __webpack_public_path__ + "img/ghana-flag.5c52a321.svg";